import {Dispatch} from "redux"
import {connect} from "react-redux"

// Models
import {RootState} from "../../../models"
import {DoctorStatsStateType} from "../models"

// Actions
import * as a from "../store/actions"

// Selectors
import {selectStatsFetching, selectStats} from "../store/selectors"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    fetchingStats: selectStatsFetching(state),
    stats: selectStats(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchStats: () => dispatch(a.fetchStatsAsync.request()),
});

export type WithDoctorStatsProps = {
    fetchingStats: DoctorStatsStateType["fetching"]
    stats: DoctorStatsStateType["stats"]
    fetchStats(): void
}

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
